import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { EmployeeDocService } from '../_services';
import * as EmployeeDocActions from '../_actions/employeeDoc';

@Injectable({
  providedIn: 'root',
})
export class EmployeeDocEffects {
  loadEmployeeDocs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EmployeeDocActions.loadEmployeeDocs),
      mergeMap(() =>
        this.employeeDocService.getEmployeeDocs().pipe(
          map((employeeDocs) => EmployeeDocActions.loadEmployeeDocsSuccess({ employeeDocs })),
          catchError((error) => of(EmployeeDocActions.loadEmployeeDocsFailure({ error })))
        )
      )
    )
  );

  addEmployeeDoc$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EmployeeDocActions.addEmployeeDoc),
      mergeMap(({ employeeDoc }) =>
        this.employeeDocService.saveEmployeeDoc(employeeDoc).pipe(
          map((savedEmployeeDoc) =>
            EmployeeDocActions.addEmployeeDocSuccess({ employeeDoc: savedEmployeeDoc })
          ),
          catchError((error) => of(EmployeeDocActions.addEmployeeDocFailure({ error })))
        )
      )
    )
  );

  updateEmployeeDoc$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EmployeeDocActions.updateEmployeeDoc),
      mergeMap(({ employeeDoc }) =>
        this.employeeDocService.saveEmployeeDoc(employeeDoc).pipe(
          map((updatedEmployeeDoc) =>
            EmployeeDocActions.updateEmployeeDocSuccess({ employeeDoc: updatedEmployeeDoc })
          ),
          catchError((error) => of(EmployeeDocActions.updateEmployeeDocFailure({ error })))
        )
      )
    )
  );

  deleteEmployeeDoc$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EmployeeDocActions.deleteEmployeeDoc),
      mergeMap(({ id }) =>
        this.employeeDocService.deleteEmployeeDoc(id).pipe(
          map(() => EmployeeDocActions.deleteEmployeeDocSuccess({ id })),
          catchError((error) => of(EmployeeDocActions.deleteEmployeeDocFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private employeeDocService: EmployeeDocService
  ) {}
}
